import { render, staticRenderFns } from "./limit.vue?vue&type=template&id=33903e40"
import script from "./limit.vue?vue&type=script&lang=js"
export * from "./limit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports